<template>
  <div class="simple-card" style="background-color: #F8F8F8">
    <h3 class="simple-card-title" style="margin: 0">{{$t('pages.ratingHistory.graph')}}</h3>
    <line-chart class="" :height="125" :options="{ scales: { yAxes: [{ ticks: {max: max, min: min} }] } }" :chartData="grafRatinga"></line-chart>
  </div>
</template>
<script>
import Line from '@/charts/Line'

export default {
  name: 'graph',
  components: {'line-chart': Line},
  props: ['ratingHistory'],
  data () {
    return {
      grafRatinga: null
    }
  },
  created () {
    this.pripraviGraf()
  },
  methods: {
    pripraviGraf () {
      let data = []
      this.timeAxis = []
      for (let i = 0; i < this.ratingHistory.length; i++) {
        console.log(this.ratingHistory[i].newRating)
        data.push(this.ratingHistory[i].newRating)
        this.timeAxis.push((i + 1) + '')
      }
      this.grafRatinga = {labels: this.timeAxis, datasets: [{label: this.$t('pages.exams.ratingResults.rating'), fill: false, borderColor: '#2872ca', data: data}]}
      this.min = Math.min.apply(null, data) - 10
      this.max = Math.max.apply(null, data) + 10
    }
  }
}

</script>

<style scoped lang="scss">
@import '../../../assets/k6styles/cards';

.simple-card {
  margin: 30px 0;
}
</style>


// WEBPACK FOOTER //
// Graph.vue?7bef572a